import React from "react";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import { login } from "../../../../lib/login"; // Adjust path as needed
import { encryptData } from "../../../../lib/crypto/crypto";
import Image from "next/image";
export default class LoginWithEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logincred: { email: "", password: "" },
      loginErrors: { email: "", password: "" },
      loginErrorMsg: "",
      onClickLoginLoader: false,
      showPassword: false,
      errorMessageString: {
        USER_NOT_ACTIVE: 'User is in-active',
        INVALID_CREDENTIALS: 'Username or password is invalid.',
        USER_NOT_FOUND: 'User does not exist. Please check your username or contact support.',
      }
    };
    this.togglePassword = this.togglePassword.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleRegisterNow = this.handleRegisterNow.bind(this);
    this.handleContinueWithMobile = this.handleContinueWithMobile.bind(this);
    this.onChangeLoginEmail = this.onChangeLoginEmail.bind(this);
    this.onChangeLoginPassword = this.onChangeLoginPassword.bind(this);
    this.onClickLoginBtn = this.onClickLoginBtn.bind(this);
    this.onBlurLoginEmail = this.onBlurLoginEmail.bind(this);
    this.onBlurLoginPassword = this.onBlurLoginPassword.bind(this);
  }

  togglePassword() {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  handleForgotPassword(e) {
    e.preventDefault();
    if (this.props.handlers && this.props.handlers.setPopupType) {
      // this.props.handlers.setPopupType("ForgotPassword");
      this.props.handlers.setPopupType({
        popupCompoenet: "login",
        popupPage: "ForgotPassword",
      });
    }
  }

  handleRegisterNow(e) {
    const regis = localStorage.getItem("regis");
    e.preventDefault();
    if (regis === "Tour Master") {
      window.location.href = "/registration";
      return;
    } else if (regis === "Vendor") {
      window.location.href = "/vendor";
    } else if (regis === "Traveler") {
      if (this.props.handlers?.setPopupType) {
        this.props.handlers.setPopupType({
          popupCompoenet: "Register",
          popupPage: "Register",
        });
      }
    }
  }

  handleContinueWithMobile() {
    if (this.props.handlers && this.props.handlers.setPopupType) {
      this.props.handlers.setPopupType({
        popupCompoenet: "login",
        popupPage: "LoginWithMobile",
      });
    }
  }

  onChangeLoginEmail(e) {
    let email = e.target.value;
    // Prevent leading spaces (typing and pasting)
    if (email.length > 0) {
      email = email.replace(/^\s+/, "");
    }
    this.setState({
      logincred: { ...this.state.logincred, email: email },
      loginErrors: { ...this.state.loginErrors, email: "" },
      loginErrorMsg: "",
    });
    if (email.length > 0) {
      const errorMsg = this.getEmailErrorMessage(email);
      if (errorMsg) {
        this.setState({
          loginErrors: { ...this.state.loginErrors, email: errorMsg },
        });
      }
    }
  }

  onBlurLoginEmail(e) {
    const email = e.target.value;
    const errorMsg = this.getEmailErrorMessage(email);
    this.setState({
      loginErrors: { ...this.state.loginErrors, email: errorMsg },
    });
  }

  onChangeLoginPassword(e) {
    let password = e.target.value;
    // Prevent leading spaces
    if (password.length === 1 && password[0] === " ") return;
    if (password.length > 1 && password[0] === " ")
      password = password.replace(/^\s+/, "");
    this.setState({
      logincred: { ...this.state.logincred, password: password },
      loginErrors: { ...this.state.loginErrors, password: "" },
      loginErrorMsg: "",
    });
    if (password.length > 0) {
      const errorMsg = this.getPasswordErrorMessage(password);
      if (errorMsg) {
        this.setState({
          loginErrors: { ...this.state.loginErrors, password: errorMsg },
        });
      }
    }
  }

  onBlurLoginPassword(e) {
    const password = e.target.value;
    const errorMsg = this.getPasswordErrorMessage(password);
    this.setState({
      loginErrors: { ...this.state.loginErrors, password: errorMsg },
    });
  }

  getEmailErrorMessage(email) {
    if (!email) return "Please enter the email id";
    if (email.includes(" ")) return "Please enter valid email id";
    if (!email.includes("@")) return "Please enter valid email id";
    const specialChars = [".", "_", "-", "@"];
    if (
      specialChars.includes(email.charAt(0)) ||
      specialChars.includes(email.charAt(email.length - 1))
    ) {
      return "Please enter valid email id";
    }
    const parts = email.split("@");
    if (parts.length !== 2) return "Please enter valid email id";
    const [local, domain] = parts;
    if (!local || local.length === 0) return "Please enter valid email id";
    if (!domain || domain.length === 0) return "Please enter valid email id";
    if (!domain.includes("."))
      return "Please enter valid email id";
    const validChars = /^[a-zA-Z0-9._-]+$/;
    if (!validChars.test(local))
      return "Please enter valid email id";
    if (!validChars.test(domain))
      return "Please enter valid email id";
    if (email.includes("..")) return "Please enter valid email id";
    const domainParts = domain.split(".");
    if (domainParts.length < 2)
      return "Please enter valid email id";
    for (let part of domainParts) {
      if (!part || part.length === 0)
        return "Please enter valid email id";
      if (!/^[a-zA-Z0-9-]+$/.test(part))
        return "Please enter valid email id";
    }
    const tld = domainParts[domainParts.length - 1];
    if (tld.length < 2 || !/^[a-zA-Z]+$/.test(tld)) {
      return "Please enter valid email id";
    }
    return "";
  }

  getPasswordErrorMessage(password) {
    if (!password) return "Please enter password";
    if (password.includes(" ")) return "Spaces are not allowed in password";
    return "";
  }

  async onClickLoginBtn(e) {
    if (e) e.preventDefault();
    const pathname = window.location.pathname

    const { email, password } = this.state.logincred;
    let errors = {};
    let isValid = true;
    this.setState({ loginErrorMsg: "", onClickLoginLoader: true });
    const emailError = this.getEmailErrorMessage(email);
    if (emailError) {
      errors.email = emailError;
      isValid = false;
    }
    const passwordError = this.getPasswordErrorMessage(password);
    if (passwordError) {
      errors.password = passwordError;
      isValid = false;
    }
    if (!isValid) {
      this.setState({
        loginErrors: errors,
        onClickLoginLoader: false,
      });
      return;
    }
    this.setState({ generalError: "", onClickLoginLoader: true });
    try {
      const encryptedPassword = encryptData(password);
      const response = await login({
        email,
        password: encryptedPassword,
        crypto: true ? true : false,
      }); // Encrypt password before sending
      if (response.status === true) {
        this.setState({ loginErrorMsg: "", onClickLoginLoader: false });
        ['/registration', '/vendor','/progress'].includes(pathname) ? window.location.href = '/' : window.location.reload(); // Reload page after successful login
      } else {
        this.setState({
          loginErrorMsg:
            this.state.errorMessageString[response.err_code] || "Login failed.",
          onClickLoginLoader: false,
        });
      }
    } catch (error) {
      let errorMessage =
        "Network error. Please check your connection and try again.";
      if (error.response) {
        this.setState({ loginErrorMsg: "", onClickLoginLoader: false });
        if (error.response.status === 401) {
          errorMessage =
            "Invalid credentials. Please check your email and password.";
        } else if (error.response.status === 404) {
          errorMessage =
            "Traveler does not exist. Please check your email or register.";
        } else if (error.response.status === 403) {
          errorMessage = "Your account is inactive. Please contact support.";
        } else if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
      this.setState({
        loginErrorMsg: errorMessage,
        onClickLoginLoader: false,
      });
    }
  }

  render() {
    const { styles, PromotionBannerCss, isMobile } = this.props;
    const {
      logincred,
      loginErrors,
      loginErrorMsg,
      onClickLoginLoader,
      showPassword,
    } = this.state;

    // --- New banner logic using PromotionBanner ---
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;

      return url;
    };
    const regis = localStorage.getItem("regis");
    // Get homeBody data (desktop version for now)

    const CustomPrevArrow = () => (
      <img src="/images/arrow_2-01.svg" width={20} height={20} alt="Previous" />
    );
    const CustomNextArrow = () => (
      <img src="/images/back-arrow.png" width={20} height={20} alt="Next" />
    );

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    const banners = this.props?.siteData?.data?.signin?.banners;
    console.log('pathname', window.location.pathname);
    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner (dynamic) */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image" // Default image key, can be adjusted
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="/images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>
        {/* Right side - Login Form */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.form_header}>
              <h3>Login</h3>
              {/* General error message for login attempts */}
              {loginErrorMsg && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{loginErrorMsg}</span>
                </div>
              )}
            </div>
            <div className={styles.form_group}>
              <label htmlFor="email">Login with Email</label>
              <div className={styles.input_container}>
                <input
                  id="email"
                  placeholder="Enter your email id"
                  className={`${styles.normal_input} ${loginErrors.email || loginErrorMsg ? styles.input_error : ""
                    }`}
                  value={logincred.email}
                  onChange={this.onChangeLoginEmail}
                  onBlur={this.onBlurLoginEmail}
                />
                {loginErrors.email && (
                  <div className={styles.error_text} id="email-error">
                    {loginErrors.email}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.form_group}>
              <label htmlFor="password">Password</label>
              <div className={styles.input_container}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter Password"
                  className={`${styles.normal_input} ${loginErrors.password || loginErrorMsg
                    ? styles.input_error
                    : ""
                    }`}
                  value={logincred.password}
                  onChange={this.onChangeLoginPassword}
                  onBlur={this.onBlurLoginPassword}
                />
                <button
                  className={styles.toggle_password}
                  onClick={this.togglePassword}
                  type="button"
                >
                  <img
                    src={
                      showPassword
                        ? "images/te_Eye_off.svg"
                        : "images/te_Eye.svg"
                    }
                    alt="Toggle Password"
                  />
                </button>
                {loginErrors.password && (
                  <div className={styles.error_text} id="password-error">
                    {loginErrors.password}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.forgot_password}>
              <a href="#" onClick={this.handleForgotPassword}>
                Forgot Password?
              </a>
            </div>
            <button
              className={`${styles.login_btn} ${this.state.onClickLoginLoader ? "loading" : ""
                }`}
              onClick={this.onClickLoginBtn}
            >
              <span>Login</span>
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>
            {/* <div className={styles.divider}>OR</div> */}
            {/* will be reverted dont remove below */}
            {/* <button
              className={styles.mobile_btn}
              onClick={this.handleContinueWithMobile}
            >
              <span>Continue with Mobile</span>
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button> */}
            <div className={styles.register_link}>
              <span>Don't have an account?</span>
              <a href="#" onClick={this.handleRegisterNow}>
                Register Now
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
